import { render, staticRenderFns } from "./CompanyView.vue?vue&type=template&id=2f50dae6&scoped=true&"
import script from "./CompanyView.vue?vue&type=script&lang=js&"
export * from "./CompanyView.vue?vue&type=script&lang=js&"
import style0 from "./CompanyView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CompanyView.vue?vue&type=style&index=1&id=2f50dae6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f50dae6",
  null
  
)

export default component.exports